import { Component, OnInit } from '@angular/core';
import { MarketplaceService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-marketplace-page',
  templateUrl: './marketplace-page.component.html',
  styleUrls: ['./marketplace-page.component.scss'],
})
export class MarketplacePageComponent implements OnInit {
  screenSize = ScreenType;

  constructor(private marketplaceService: MarketplaceService) {}

  ngOnInit() {
    this.marketplaceService.fetchMarketplaceItems().toPromise();
  }
}
